import { Component, OnInit } from '@angular/core';
import { BaseDetailListSum, UserService } from 'yt-ng-framework';
import { IzvodStavkaView } from './izvod-stavka-view';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'yt-izvod-sum',
  templateUrl: './izvod-sum.component.html'
})
export class IzvodSumComponent extends BaseDetailListSum<IzvodStavkaView> {

  constructor(
    protected decimalPipe: DecimalPipe,
    protected userService: UserService
){
    super();
}

  private _ukupnoDuguje: number = 0;
  private _ukupnoPotrazuje: number = 0;

  ukupnoDuguje: string;
  ukupnoPotrazuje: string;

  calculate(){
    super.calculate();

    this._ukupnoDuguje=0;
    this._ukupnoPotrazuje=0;

    if(this.Items && this.Items.size > 0){
      this.Items.forEach((item: IzvodStavkaView) => {
        this._ukupnoDuguje += item.Duguje;
        this._ukupnoPotrazuje += item.Potrazuje;
      })

    }

    this.ukupnoDuguje = this.decimalPipe.transform(this._ukupnoDuguje, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
    this.ukupnoPotrazuje = this.decimalPipe.transform(this._ukupnoPotrazuje, this.userService.GetNumberFormat(), this.userService.GetLocaleString());


  }

}
